<template>
<div>
  <div class="cart-content container">
    <div class="noticemsg-alt" v-if ="$store.getters.getCartData.items !== undefined && $store.getters.getCartData.items !== null && $store.getters.getCartData.items.length == 0">
      <span>  Cart is empty :(</span>
      <br/><span> Start by adding any of the below course/concept in cart</span>
    </div>
    <div class="card" v-else>
      <!-- title -->
      <div class="row">
        <div class="col-12">
          <h1 class="card-title">{{$t('cart.labels.cart')}}</h1>
        </div>
      </div>

      <div class="card-content">
        <br>
        <!-- search bar -->
        <b-form-input placeholder ="search items from cart" v-if="$store.getters.getCartData.items !== undefined && $store.getters.getCartData.items !== null && $store.getters.getCartData.items.length>0" type ="text" v-model="keyWord"></b-form-input>
        <!-- showing number of items -->
        <div v-if="keyWord.length == 0" class="row justify-content-end details-1">
          
          <h6 class="col-7 text-left" v-if="$store.getters.getCartData.items !== undefined && $store.getters.getCartData.items !== null && $store.getters.getCartData.items.length <= 1">
            <strong>{{$store.getters.getCartData.items.length}} {{$t('cart.labels.ItemInYourCart')}}</strong>
          </h6>
          <h6 class="col-7 text-left" v-else>
            <strong>{{$store.getters.getCartData.items.length}} {{$t('cart.labels.ItemsInYourCart')}}</strong>
          </h6>
          <h6 class="col-5 text-right">
            <strong>{{$t('cart.labels.Cost')}}</strong>
          </h6>
        </div>
        <br>
        <!-- <div class="row details-2" v-if ="$store.getters.getCartData.items !== undefined && $store.getters.getCartData.items !== null && $store.getters.getCartData.items.length > 0" v-for="(cartItem,index) in $store.getters.getCartData.items" :key="index"> -->
        <div class="row details-2" v-if ="$store.getters.getCartDataMatchingKeyWord(keyWord) !== undefined && $store.getters.getCartDataMatchingKeyWord(keyWord) !== null && $store.getters.getCartDataMatchingKeyWord(keyWord).length > 0" v-for="(cartItem,index) in $store.getters.getCartDataMatchingKeyWord(keyWord)" :key="index">
          <div class="px-3 img-css">
            <img :src="makePath(cartItem.thumbnail,cartItem.itemType)"  alt="">
          </div>
          <div class="col-7 description">
            <div class="c-title">{{cartItem.itemName}}</div>
            <div class="cart-actions">
              <button class="btn btn-danger" title="Delete" @click="deleteOnCart(cartItem.itemId)">
                <i class="mdi mdi-delete" aria-hidden="true"></i> Delete
              </button>
            </div>
          </div>
          <div class="col cost text-right" v-if="cartItem.amount<=1">
              {{cartItem.amount}}  {{$t('cart.labels.Point')}}
          </div> 
          <div class="col cost text-right" v-else>
              {{cartItem.amount}} {{$t('cart.labels.Points')}}
          </div>
        </div>
        <div class="row coupon-total">
          <div class="col  coupoun-css"  v-if ="keyWord.length == 0">
            {{$t('cart.labels.RedeemedMsg')}}  {{$t('cart.labels.NoCashTransactionMsg')}}
          </div>

          <!-- points required for payment -->
          <div class="col text-right total-amt" v-if ="keyWord.length == 0">
            <div v-if="(total<=1)">
              <span > {{$t('cart.labels.TotalPointsReq')}} </span> {{total}} {{$t('cart.labels.Point')}}
              </div>
              <div v-else>
                <span > {{$t('cart.labels.TotalPointsReq')}} </span> {{total}} {{$t('cart.labels.Points')}}
              </div>
              <div class="pt-5" v-if="$store.getters.getCartData.items.length!==0 && keyWord.length == 0">
                <button @click="clearUserCart()" class="btn btn-large btn-danger "> Clear Cart</button>
                <b-link class="btn btn-large btn-main ml-0 hov" :to="{ name: 'confirmation', params: {'cartId':this.$store.getters.getCartData.cartId, 'profileId': this.$store.getters.getProfileDetails.profileId,'amount': total }}">
                  {{$t('cart.labels.ProceedToRedem')}}
                </b-link>
              </div>
            <div class="pt-5" v-else>
             
              <button v-if ="keyWord.length == 0" class="btn btn-large btn-main  hov" @click="checkCart()">{{$t('cart.labels.ProceedToRedem')}}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>
<script>
// import axios from 'axios'
require('vue-animate/dist/vue-animate.min.css')
import { CDP_CDN_THUMBNAIL_URL } from '@/components/common/constants.js'
import axios from 'axios'
export default {
  name: 'cartContent',
  data () {
    return {
      itemId: '',
      keyWord: ''
    }
  },
  created () {
    this.$store.dispatch('viewCartData', this.$store.getters.getProfileDetails.profileId)
  },
  computed: {
    total () {
      var total1 = 0
      if (this.$store.getters.getCartData.items !== undefined && this.$store.getters.getCartData.items !== null) {
        for (let index = 0; index < this.$store.getters.getCartData.items.length; index++) {
          total1 = total1 + parseInt(this.$store.getters.getCartData.items[index].amount)
        }
      }
      return total1
    },
    isLoggedIn () {
      return this.$store.getters.getIsLoggedIn
    }
  },
  methods: {
    clearUserCart () {
      this.$swal({
        title: 'Do yo want to remove all the items from cart ?',
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then(willDelete => {
        if (willDelete) {
          return new Promise((resolve, reject) => {
            axios
            .post('r/clearUserCart', {'profileId': this.$store.getters.getProfileDetails.profileId})
            .then(res => {
              if (res.status === 200) {
                this.$store.dispatch('clearCartItemsInStore').then(res => {
                  this.$toasted.success('cart emptied')
                  resolve()
                }, err => {
                  console.log('ERROR_IN_CLEARING_CART_ITEMS : ', err)
                  reject()
                })
              } else {
                reject()
              }
            })
            .catch(err => {
              console.log('ERROR_IN_CLEARING_CART : ', err)
              this.$toasted.error('something went wrong')
              reject(err)
            })
          })
        }
      })
    },
    deleteOnCart (itemId) {
      this.$swal({
        title: this.$t('cart.alerts.RemovalConfirmation'),
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then(willDelete => {
        if (willDelete) {
          this.$store.dispatch('deleteData', { itemId: itemId, profileId: this.$store.getters.getProfileDetails.profileId, cartId: this.$store.getters.getCartData.cartId }).then(
            response => {
              this.$toasted.success(this.$t('cart.alerts.DeletedFromCart'))
              if (!this.$store.getters.itemPresentInWishListStatus(itemId)) {
                this.addToWishList(itemId)
              }
            },
            error => {
              console.log('Error in deleting item to cart', error)
            }
          )
        }
      })
    },
    checkCart () {
      this.$toasted.error(this.$t('cart.alerts.AddItemToCart'))
    },
    makePath (path, type) {
      if (path.length !== 0) {
        return CDP_CDN_THUMBNAIL_URL + '/' + path
        // return 'http://10.2.10.230:3035/cdpcdn/thumnail/' + path
      } else {
        if (type === 'CO') {
          return '../../../static/assets/images/defaultCO.jpg'
        } else if (type === 'LO') {
          return '../../../static/assets/images/defaultLO.jpg'
        }
      }
    },
    addToWishList (itemId) {
      if (this.isLoggedIn) {
        // if user is loggedIn then call to insert api
        this.$store.dispatch('insertWishListInDb', { profileId: this.$store.getters.getProfileDetails.profileId, itemId: itemId }).then(
          response => {
            // this.$toasted.success('Item added to wishlist')
          },
          error => {
            console.error('error in adding item to wishList', error)
          }
        )
      } else {
        window.MKCLAPI.login()
      }
    }
  }
}
</script>
<style lang="scss">
@import '../../../static/assets/styles/scss/variables.scss';

.cart-content {
  padding-bottom: 30px;
  .hov {
    color: #fff;
  }
  .card {
    border-radius: 4px; overflow: hidden;
    box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.18);
    border: none;
    transition: box-shadow 0.25s;
    .card-title {
      text-align: center;
      text-transform: uppercase;
      padding: 20px;
      margin-bottom: 0;
      letter-spacing: 0.7px;
      font-weight: 300;
      font-family: $opensans;
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
      background: linear-gradient(to right, #3ac0de 0%, #aa67dd 100%);
      color: #fff;
      font-size: 24px;
    }
    .card-content {
      padding-left: 15px; padding-right: 15px;
      background-color: #fff;
      /*margin-bottom: 25px;*/
      .details-1 {
        font-family: $opensans;
        color: #222;
        padding: 20px 15px;
        border-bottom: 1px solid rgba(0,0,0,.1);
        h6 {margin-bottom: 0;}
      }
      .details-2 {
        padding: 20px 15px;
        border-bottom: 1px solid #e8e8e8;
        background: #f8f8f8;
      }
      .img-css {
        img {
          width: 180px;
          height: auto;
          border-radius: 3px;
          // padding-bottom:15px;
        }
        // &:after {
        //   display: block;
        //   position: relative;
        //   background-image: linear-gradient(to right, rgba(92, 184, 234, 0.7) 0%, rgba(110, 99, 197, 0.7) 100%);
        //   margin-top: -130px;
        //   height: 130px;
        //   width: 100%;
        //   border-radius: 5px;
        //   content: '';
        // }
      }
      .cost {
        font-family: $opensans;
        font-weight: 600;
        font-size: 15px;
      }
      .description {
        .c-title {
          font-family: $opensans;
          font-weight: 600;
          font-size: 16px; line-height: 24px;
        }
        p {
          color: #555;
          font-size: 12px;
        }
      }
      .cart-actions {
        transition: all 0.3s;
        display: block;
        .wishlist {
          font-size: 12px;
          color: #555;
          .fa {
            font-size: 18px;
            color: #ff6c8a;
            padding: 10px 10px 10px 0px;
          }
          &:hover {
            cursor: pointer;
            color: #222;
            .fa {
              color: darken(#ff6c8a, 8%);
            }
          }
        }
        .delete-icon {
          font-size: 18px;
          margin-top: 7px;
          color: #999;
          border: 1px solid #ff7373;
          padding: 2px 7px;
          border-radius: 3px;
          margin-top: 10px;
          color: #ff7373;
          display: inline-block;
          width: 30px;
          height: 30px; 
          transition: 300ms ease;
          // float: right;
          &:hover {
            color: #fff;
            background: #ff7373;
            cursor: pointer;
          }
        }
      }
      .coupon-total {padding: 30px 15px;}
      .coupoun-css {
        color: #333;
        font-family: $opensans;
        font-weight: 500;
        font-size: 14px; line-height: 24px;
      }
      .total-amt {
        font-family: $opensans;
        font-size: 18px;
        font-weight: 700;
        // span {
        //   display: inline;
        //   padding-right: 70px;
        // }
      }
    }
    &:hover {
      transition: box-shadow 0.45s;
      box-shadow: 0px 15px 25px rgba(0, 0, 0, 0.25);
    }
  }

  .cart-actions {margin-top: 15px;
    .btn-danger {padding: 4px 14px 4px 12px; border-color: #ccc; border-radius: 3px; font-size: 10px; line-height: 20px; font-weight: 600; letter-spacing: 0; color: #aaa; background: transparent;
      i {margin-right: 3px; font-size: 16px;}
      &:hover, &:focus {border-color: #e44848; color: #fff; background: #e44848;}
    }
  }


.btn.btn-large.btn-main {background: linear-gradient(to right, #3ac0de, #aa67dd); background-position: -1px 0; background-size: 200% 100%; transition: all 0.25s ease-out; margin-left:-22px;
  &:active, &:hover, &:focus {background-position: 99% 0;}
}

@media screen and (max-width:500px) {
  .img-css{img{padding-bottom:15px;}}
    .total-amt {
      padding-top:40px;
      div{text-align: center;}
      // display: block;
        span {
          display: block;
        }
      }
}
@media screen and (min-width:501px) {
    .total-amt {
      padding-top:0px;
        span {
          display: inline;
          padding-right: 70px;
        }
      }
}
}
</style>



// WEBPACK FOOTER //
// src/components/cart/cartContent.vue?68e8206e